$(document).ready(function () {
    
  var cache = {};
  // $('.search-by-code [name="postcode"]').autocomplete({
  $('.autocomplete-postcode').autocomplete({
    minLength: 1,
    source: async function( request, response ) {
        console.log('calling source');
      var term = request.term;
      if ( term in cache ) {
        response( cache[ term ] );
        return;
      }

      const res = await fetch(`https://api.postcodes.io/postcodes/${term}/autocomplete`);
      const { result } = await res.json();
      console.log('Res', result);
      response( result );
    }
  }).focus(function(){
    $(this).autocomplete("search");
  });
});
